import React from 'react';

import { Box } from '@material-ui/core';

import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
// import LoginFormAnswer from "./LoginForm";
import LandingNext from '../../Landing/Next';
// import LandingAnswer from "../../Landing/Answer";
import { useLoginForm } from '../hooks';

const LoginAnswer = () => {
  const { isOpenDialog, closeDialog, dialog, handleSubmit, isLoading } =
    useLoginForm();

  if (isLoading) {
    return (
      <Box display="block">
        <Loader action={'Iniciando sesión'} />
      </Box>
    );
  }

  return (
    <>
      <SharedDialog
        open={isOpenDialog}
        title={dialog?.title}
        content={dialog?.content}
        actions={dialog?.action}
        onClose={closeDialog}
      />
      {/* <LandingAnswer>
        <LoginFormAnswer handleSubmit={handleSubmit} />
      </LandingAnswer> */}
      <LandingNext handleSubmit={handleSubmit} />
    </>
  );
};

LoginAnswer.displayName = 'LoginAnswer';
export default LoginAnswer;
